export default {
  goodsStatusEnum: {
    '-1': 'Zahlung ausstehend',
    0: 'In Überprüfung',
    1: 'Bestätigung ausstehend',
    2: 'Rückzahlung ausstehend',
    3: 'Ware zurücksenden',
    4: 'Ware umtauschen',
    5: 'Verkäufer hat versandt',
    6: 'Separate Lieferung',
    7: 'Verzögerte Bearbeitung',
    8: 'Zugestellt',
    9: 'Wird eingelagert',
    10: 'Eingelagert',
    11: 'Ungültig',
    12: 'Zerstört',
    13: 'Abgelaufen',
    14: 'Informationsbestätigung',
    15: 'Kaufbestätigung',
    16: 'Wartet auf Rücksendung',
    17: 'Wartet auf Umtausch',
    18: 'Rücksendung wird bearbeitet',
    19: 'Umtausch wird bearbeitet',
    20: 'Zurückgesendet',
    21: 'Umgetauscht',
    22: 'Gekauft',
    23: 'In Bearbeitung',
    24: 'Storniert',
    25: 'Anormale Bestellung',
    26: 'Wartet auf Rückerstattung',
    27: 'Wartet auf erneuten Versand',
    28: 'Wird eingesammelt',
    29: 'Verpackung abgeschlossen',
    30: 'International versandt',
    31: 'Erhalten',
    32: 'Bestellung abgelehnt (Zahlung)',
    33: 'Risikokontrolle',
    34: 'Rückerstattung abgeschlossen',
    35: 'Liste der eingefrorenen Bestellungen',
    36: 'Vorauszahlung',
    37: 'Wartet auf Abholung',
    38: 'Rückerstattung in Bearbeitung',
    39: 'Abgelehnte Ware',
    40: 'Ablehnung abgeschlossen',
    41: 'Ausnahme: Nicht auf Lager',
    42: 'Ausnahme: Auf Lager',
    43: 'Rücksendung storniert',
    44: 'Umtausch storniert',
    45: 'Unterschrieben und ausstehend',
    46: 'Auftragsabwicklung',
    47: 'Bestellbearbeitung',
    48: 'Zahlung abgeschlossen',
    49: 'Aufgegeben',
    50: 'Abgeschlossen',
    51: 'Rücksendung wartet auf Genehmigung des Verkäufers',
    52: 'Umtausch wartet auf Genehmigung des Verkäufers',
    53: 'Ungültiges Rücksendepaket',
    54: 'Wird generiert',
    55: 'Bestellbearbeitung',
    58: 'Ware im Transfer',
  },
  appendStatusEnum: {
    0: 'Ausstehend',
    1: 'In Bearbeitung',
    2: 'Storniert',
    3: 'Abgeschlossen',
    4: 'Zurückgesendet',
  },
  inviteStatusEnum: {
    0: 'Nicht aktiv',
    1: 'Aktiv',
  },
}
